import axios from 'axios';
import { ROOT_URL } from './config';

// 웹 전용 미디어 업로드 api
export function getFramesFromMedia(req) {
	return axios.post(ROOT_URL + `/api/v1/media/basic/`, req.data, {
		headers: req.headers,
	});
}
